import { FlexibleInputCalendar, FlexibleInputCalendarProps } from './FlexibleInputCalendar';
import { StructuredInputCalendar, StructuredInputCalendarProps } from './StructuredInputCalendar';

export type CalendarWithDateTimeFieldsProps = StructuredInputCalendarProps | FlexibleInputCalendarProps;

export const CalendarWithDateTimeFields = (props: CalendarWithDateTimeFieldsProps) => {
  if (props.inputMode === 'flexible') {
    return <FlexibleInputCalendar {...props} />;
  }

  return <StructuredInputCalendar {...props} />;
};
